import type { ComponentType } from 'react';

import { ArticleEditorProvider } from '@xing-com/crate-articles-article-editor';
import type { Xinglet } from '@xing-com/crate-xinglet';

import { default as ArticleViewerPage } from './article-viewer';
import type { ArticleViewerProps } from './types';

export default class ArticleViewer implements Xinglet {
  public getComponent(): ComponentType<ArticleViewerProps> {
    return (props: ArticleViewerProps) => (
      <ArticleEditorProvider>
        <ArticleViewerPage {...props} />
      </ArticleEditorProvider>
    );
  }
}
